// extracted by mini-css-extract-plugin
export default {"loadingIcon":"routingContainer_loadingIcon__1NSIk","loadingContainer":"routingContainer_loadingContainer__s3POf"};